<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="false" :searchable="false" label="name" placeholder="Ед. изм." v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex align-items-center">
                {{ scope.option.name }}
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex align-items-center">
                {{ scope.option.name }}
            </div>
        </template>
    </search-select>
</template>

<script>
import SearchSelect from '@/components/Select'

const options = [
    {
        id: 1,
        name: 'шт'
    },
    {
        id: 2,
        name: 'мл'
    },
    {
        id: 3,
        name: 'гр'
    }
]

export const getUnitText = value => {
    const option = options.find(option => option.id === parseInt(value))
    return option ? option.name : null
}

export const units = options

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    computed: {
        options() {
            return options
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    }
}
</script>
